/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { slot } from './slot';

export class day extends IceEntity {
    day_key: string = "";
    interval: IceTypes.interval = IceTypes.interval.interval15;
    date_of_day: any = NaN;
  SLOTS: slot[] = [];

    gettablename(): string {
        return "DAY";
    }

    hassubtree(ColumnName: string): boolean {
        if (ColumnName.length == 0) return false;
        else if (ColumnName == "SLOTS") return true;

        return false;
    }

    getsubtreetablename(ColumnName: string): string {
        if (ColumnName.length == 0) return null;
        else if (ColumnName == "SLOTS") return "SLOT";

        return null;
    }
}
